import * as React from 'react';

import { block } from './utils';

const ToolGroup: React.SFC = ({ children }) => (
  <div className={block('tool-group')}>{children}</div>
);

export default ToolGroup;
